import { render, staticRenderFns } from "./leaseRequests.vue?vue&type=template&id=2c169b74"
import script from "./leaseRequests.vue?vue&type=script&lang=js"
export * from "./leaseRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports